import { render, staticRenderFns } from "./ChannelConfigPage.vue?vue&type=template&id=431df4b2&scoped=true"
import script from "./ChannelConfigPage.vue?vue&type=script&lang=js"
export * from "./ChannelConfigPage.vue?vue&type=script&lang=js"
import style0 from "./ChannelConfigPage.vue?vue&type=style&index=0&id=431df4b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431df4b2",
  null
  
)

export default component.exports